import FormHocImport from './FormHoc';
import CheckboxImport, { Checkbox as CheckboxBaseImport } from './elements/Checkbox';
import FileImport, { File as FileBaseImport } from './elements/File';
import InputImport, { Input as InputBaseImport } from './elements/Input';
import MultiSelectImport, { MultiSelect as MultiSelectBaseImport } from './elements/MultiSelect';
import SelectImport, { Select as SelectBaseImport } from './elements/Select';
import TextAreaImport, { TextArea as TextAreaBaseImport } from './elements/TextArea';
import './form.scss';

export const FormHoc = FormHocImport;
export const Checkbox = CheckboxImport;
export const File = FileImport;
export const Input = InputImport;
export const MultiSelect = MultiSelectImport;
export const Select = SelectImport;
export const TextArea = TextAreaImport;

export const CheckboxBase = CheckboxBaseImport;
export const FileBase = FileBaseImport;
export const InputBase = InputBaseImport;
export const MultiSelectBase = MultiSelectBaseImport;
export const SelectBase = SelectBaseImport;
export const TextAreaBase = TextAreaBaseImport;
